import React from "react";
import "./Review.css";

const Review = () => {
  return (
    <div className="review section">
      <h1 className="section-title">Product Reviews</h1>
      <p>No reviews yet.</p>
    </div>
  );
};

export default Review;
